import { get } from 'lodash'

const getUser = () => get(window, 'state.user')

export default getUser
